/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Statistics_Unscored_HintInputs */

const en_admin_statistics_unscored_hint = /** @type {(inputs: Admin_Statistics_Unscored_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} application(s) without a calculated matching score were excluded from this evaluation.`)
};

const de_admin_statistics_unscored_hint = /** @type {(inputs: Admin_Statistics_Unscored_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Bewerbung(en) ohne berechneten Matching Score wurden in dieser Auswertung nicht berücksichtigt.`)
};

/**
* | output |
* | --- |
* | "{count} application(s) without a calculated matching score were excluded from this evaluation." |
*
* @param {Admin_Statistics_Unscored_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_unscored_hint = /** @type {((inputs: Admin_Statistics_Unscored_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Unscored_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_unscored_hint(inputs)
	return en_admin_statistics_unscored_hint(inputs)
});